import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../lib/shared/validators";
import { modulesTypes } from "../../system/permissions";

export const subscriptionStatus = v.union(
  v.literal("trialing"),
  v.literal("active"),
  v.literal("past_due"),
  v.literal("canceled"),
  v.literal("incomplete"),
);

export const validatorCompanySubscription = v.object({
  // Relación con empresa (1:1)
  companyId: v.id("companies"),
  planId: v.id("subscription_plans"),

  // IDs de Dodo Payments (null durante trial)
  dodoSubscriptionId: v.optional(v.string()),
  dodoCustomerId: v.optional(v.string()),

  // Estado
  status: subscriptionStatus,

  // Fechas importantes
  trialStart: v.number(),
  trialEnd: v.number(),
  gracePeriodEnd: v.optional(v.number()),

  // Límites SOFT (copiados del plan al momento de creación)
  limits: v.object({
    maxUsers: v.number(),
    maxBranches: v.number(),
    storageGB: v.number(),
    invoicesPerMonth: v.number(),
    // AI Assistant limits (0 = disabled, -1 = unlimited)
    aiMessagesPerMonth: v.optional(v.number()),
    aiTokensPerMonth: v.optional(v.number()),
  }),

  // Contadores de uso actual
  currentUsage: v.object({
    userCount: v.number(),
    branchCount: v.number(),
    storageUsedGB: v.number(),
    invoicesThisMonth: v.number(),
    lastInvoiceReset: v.number(),
    // AI usage counters
    aiMessagesThisMonth: v.optional(v.number()),
    aiTokensThisMonth: v.optional(v.number()),
    lastAiReset: v.optional(v.number()),
  }),

  // Notificaciones enviadas
  notificationsSent: v.object({
    trialEnding: v.boolean(),
    limitsWarning: v.array(v.string()),
    gracePeriod: v.boolean(),
    exceededLimits: v.array(v.string()),
  }),

  // Módulos habilitados (copiados del plan)
  enabledModules: v.array(modulesTypes),

  internalControl,
});

export const company_subscriptions = defineTable(validatorCompanySubscription)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_company", ["companyId"])
  .index("by_status", ["status"])
  .index("by_trial_end", ["trialEnd"])
  .index("by_grace_period_end", ["gracePeriodEnd"])
  .index("by_company_and_status", ["companyId", "status"])
  .index("by_state", ["internalControl.state"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "companyId",
    "internalControl.createdAt",
  ]);
